import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// Font.register({
//   family: 'Times-Roman',
// });

const styles = StyleSheet.create({
  page: {
    fontSize: '13px',
    fontFamily: 'Times-Roman',
  },
  sideBySideSection: {
    flexDirection: 'row',
    gap: '20px',
    justifyContent: 'space-between',
  },
  section: {
    margin: 10,
    padding: 10,
    // flexGrow: 1,
  },
  subSection: {
    marginBottom: 10,
  },
  headerText: {
    fontFamily: 'Times-Bold',
    paddingBottom: 10,
  },
  table: {
    width: '100%',
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    borderTop: '1px solid #EEE',
    // paddingTop: 8,
    // paddingBottom: 8,
    padding: 8,
  },
  header: {
    borderTop: 'none',
    // border: '1px solid red',
    fontFamily: 'Times-Bold',
  },
  subHeader: {
    fontFamily: 'Times-Bold',
    // borderTop: 'none',
    textAlign: 'center',
    width: '100%',
    borderTop: '2px solid #EEE',
    paddingTop: '10px',
  },
  subtotal: {
    fontFamily: 'Times-Bold',
    borderTop: 'none',
  },
  total: {
    fontFamily: 'Times-Bold',
    fontSize: '14px',
    borderTop: '2px solid #EEE',
  },
  orderend: {
    borderTop: '2px solid #EEE',
    paddingTop: '20px',
  },
  bold: {
    fontFamily: 'Times-Bold',
  },
  smalltext: {
    paddingTop: '2px',
    fontSize: '10px',
    // verticalAlign: 'bottom',
  },
  column1: {
    width: '10%',
    textAlign: 'right',
    paddingRight: '20px',
  },
  column2: {
    width: '90%',
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  itemName: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    flexWrap: 'wrap',
  },
  listItem: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    fontSize: '12px',
  },
});

const PdfOrderForKitchen = (props) => {
  const {
    deliveryDateAndTimeForDisplay,
    deliveryLocationForDisplay,
    recordDetails,
    orderContacts,
    orderItems,
    additionalCharges,
    selectedRestaurant,
  } = props;

  // console.log('##### PdfOrderForKitchen - recordDetails #####', recordDetails);
  // console.log('orderItems', orderItems);

  const showTeamContact = false;
  const showRestaurantPhoneNumber = true;
  const showRestaurantEmail = true;
  const showAdditionalChargesHeader = true;
  const showDescription = false;
  const showDetails = false;

  const orderNumber = recordDetails ? recordDetails.orderNumber : '';
  const orderStatus = recordDetails ? recordDetails.overallOrderStatus : '';

  return (
    <Document>
      <Page style={styles.page}>
        <View style={styles.sideBySideSection}>
          <View style={styles.section}>
            <Text style={styles.headerText}>Delivery Date</Text>
            {deliveryDateAndTimeForDisplay ? <Text>{deliveryDateAndTimeForDisplay}</Text> : null}
          </View>

          <View style={styles.section}>
            <Text style={styles.headerText}>Order Number</Text>
            {orderNumber ? <Text>{orderNumber}</Text> : null}
          </View>

          <View style={styles.section}>
            <Text style={styles.headerText}>Order Status</Text>
            {orderStatus ? <Text>{orderStatus}</Text> : null}
          </View>
        </View>

        <View style={styles.sideBySideSection}>
          <View style={styles.section}>
            <Text style={styles.headerText}>Delivery Address</Text>
            {recordDetails ? <Text>{recordDetails.teamName}</Text> : null}

            {deliveryLocationForDisplay ? (
              <>
                <Text>{deliveryLocationForDisplay.name}</Text>
                <Text>{deliveryLocationForDisplay.addressLine1}</Text>
                <Text>{deliveryLocationForDisplay.addressLine2}</Text>
              </>
            ) : null}
          </View>

          <View style={styles.section}>
            <Text style={styles.headerText}>Restaurant</Text>
            {selectedRestaurant ? <Text>{selectedRestaurant.name}</Text> : null}

            {selectedRestaurant ? (
              <>
                <Text>{selectedRestaurant.address}</Text>
                <Text>
                  {selectedRestaurant.city +
                    ', ' +
                    selectedRestaurant.state +
                    ', ' +
                    selectedRestaurant.zipcode}
                </Text>
                {showRestaurantPhoneNumber ? <Text>{selectedRestaurant.phone}</Text> : null}
                {showRestaurantEmail ? <Text>{selectedRestaurant.email}</Text> : null}
              </>
            ) : null}
          </View>

          {showTeamContact ? (
            <>
              {Array.isArray(orderContacts) && orderContacts.length > 0 ? (
                <View style={styles.section}>
                  <Text style={styles.headerText}>
                    {orderContacts.length === 1 ? 'Contact' : 'Contacts'}
                  </Text>

                  {orderContacts.map((record, index) => (
                    <View style={styles.subSection} key={index}>
                      <Text>{record.name}</Text>
                      <Text>{record.position}</Text>
                      <Text>{record.phone}</Text>
                      <Text>{record.email}</Text>
                    </View>
                  ))}
                </View>
              ) : null}
            </>
          ) : null}
        </View>

        <View style={styles.section}>
          <View style={styles.table}>
            <View style={[styles.row, styles.bold, styles.header]}>
              <Text style={styles.column1}>Qty</Text>
              <Text style={styles.column2}>Item</Text>
            </View>

            {Array.isArray(orderItems) && orderItems.length > 0 ? (
              <>
                {orderItems.map((row, i) => (
                  <View key={i} style={styles.row} wrap={false}>
                    <Text style={styles.column1}>{row.quantity}</Text>
                    <View style={styles.column2}>
                      {/* <Text>{row.name}</Text> */}

                      <View style={styles.itemName}>
                        <Text>{row.name}</Text>
                        {row.feeds ? (
                          <Text style={styles.smalltext}>
                            {row.servingSize
                              ? '(Feeds ' + row.feeds + ' - ' + row.servingSize + ') '
                              : '(Feeds ' + row.feeds + ')'}
                          </Text>
                        ) : null}
                      </View>

                      {showDescription && row.description ? (
                        <View style={styles.listItem}>
                          <Text>*</Text>
                          <Text>{row.description}</Text>
                        </View>
                      ) : null}

                      {showDetails && row.details ? (
                        <View style={styles.listItem}>
                          <Text>*</Text>
                          <Text>{row.details}</Text>
                        </View>
                      ) : null}

                      {row.specialInstructions ? (
                        <View style={styles.listItem}>
                          <Text>*</Text>
                          <Text>{row.specialInstructions}</Text>
                        </View>
                      ) : null}
                    </View>
                  </View>
                ))}
              </>
            ) : null}

            {Array.isArray(additionalCharges) && additionalCharges.length > 0 ? (
              <>
                {showAdditionalChargesHeader ? (
                  <View style={[styles.row, styles.subHeader]} wrap={false}>
                    <Text>Additional Items</Text>
                  </View>
                ) : null}

                {additionalCharges.map((row, i) => (
                  <View key={i} style={styles.row} wrap={false}>
                    <Text style={styles.column1}>{row.quantity}</Text>
                    <View style={styles.column2}>
                      <Text style={styles.column2}>{row.name}</Text>
                      {row.description ? (
                        <View style={styles.listItem}>
                          <Text>*</Text>
                          <Text>{row.description}</Text>
                        </View>
                      ) : null}
                    </View>
                  </View>
                ))}
              </>
            ) : null}
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PdfOrderForKitchen;
